export { default } from './MaxDiscountInfo';
